export const FETCH_CONTENT = 'FETCH_CONTENT';
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_FAILURE = 'FETCH_CONTENT_FAILURE';
export const FILTER_CONTENT = 'FILTER_CONTENT';
export const HIDE_CONTENT = 'HIDE_CONTENT';
export const HIDE_CONTENT_SUCCESS = 'HIDE_CONTENT_SUCCESS';
export const UNHIDE_CONTENT = 'UNHIDE_CONTENT';
export const UNHIDE_CONTENT_SUCCESS = 'UNHIDE_CONTENT_SUCCESS';
